<template>
  <div class="lg:pt-28 md:pt-24 pt-20 bg-white lg:px-12 md:px-8 px-5">
    <h2 class="fsize28 sm-fsize20px font-semibold text-primary">
      Cancel Subscription
    </h2>
    <p>
      <span class="text-primary">Note: </span>Lorem ipsum dolor sit amet
      consectetur adipisicing elit. Quos consequatur sit minima sint rem
      cupiditate, asperiores, recusandae nihil accusantium amet, excepturi quo
      culpa sequi delectus expedita consequuntur at atque eligendi.
    </p>
    <div class="lg:flex bg-white gap-4 pt-8 pb-10">
      <div class="lg:w-3/5">
        <div class="custplanoverview rounded-md">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt=""
            class="w-full h-200px custimgradius1"
          />
          <div class="px-4 py-2">
            <p class="text-black font-semibold fsize18px">
              {{ getAllPayments.result[0].membershipName }}
            </p>
            <div class="flex gap-1 py-1">
              <p class="text-primary">Valid till :</p>
              <p>
                {{
                  new Date(
                    getAllPayments.result[0].userId.membershipValidity
                  ).toLocaleDateString("en-Gb", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })
                }}
              </p>
            </div>
            <p>
              {{ getAllPayments.result[0].membershipId.description }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="lg:w-4/5 lg:px-20 md:px-4 px-4 lg:ml-10 lg:pt-0 md:pt-5 pt-5 lg:mt-0 md:mt-5 mt-5 custborleft5"
      >
        <h2 class="text-black fsize20 font-semibold">
          Reason for Cancel your subscription
        </h2>
        <div class="py-2">
          <el-radio
            v-model="radio"
            label="1"
            value="Lorem, ipsum dolor sit amet adipisicing elit."
            >Lorem, ipsum dolor sit amet adipisicing elit.</el-radio
          >
          <br />
          <el-radio
            v-model="radio"
            label="2"
            value="Lorem, ipsum dolor sit amet adipisicing elit."
            >Lorem, ipsum dolor sit amet adipisicing elit.
          </el-radio>
          <br />
          <el-radio
            v-model="radio"
            label="3"
            value="Lorem, ipsum dolor sit amet adipisicing elit."
            >Lorem, ipsum dolor sit amet adipisicing elit.</el-radio
          >
          <br />
          <el-radio
            v-model="radio"
            label="4"
            value="Lorem, ipsum dolor sit amet adipisicing elit."
            >Lorem, ipsum dolor sit amet adipisicing elit.</el-radio
          >
          <br />
          <el-radio
            v-model="radio"
            label="5"
            value="Lorem, ipsum dolor sit amet adipisicing elit."
            >Lorem, ipsum dolor sit amet adipisicing elit.</el-radio
          >
          <br />
          <el-radio v-model="radio" label="6" value="Others">Others</el-radio>
        </div>
        <!-- <div v-if="radio == 6">
          <el-input
            type="textarea"
            placeholder="Specify reason to cancel"
            width="50px"
            rows="5"
            v-model="summary"
            :rules="{ required: true }"
            class="justify-center bg-f3f3f3 my-3"
          >
          </el-input>
        </div> -->
        <div class="custplanoverview p-4 mb-2">
          <div class="flex gap-8 items-center">
            <p>
              <!-- Designed exclusively for visitors seeking a glimpse into our
                offerings -->
              {{ getAllPayments.result[0].membershipId.description }}
            </p>
          </div>
        </div>
        <div class="pt-3">
          <base-button outline type="primary" @click="cancelPlan"
            >Submit</base-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      radio: 1,
    };
  },
  computed: {
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("payment", { getAllPayments: "getAllPayments" }),
  },
  methods: {
    cancelPlan() {
      try {
        this.$swal
          .fire({
            title: "Cancel Subscription",
            text: "Are you sure you want to cancel your subscription?",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#830c81",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, cancel it!",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: "profile" });
              const data = await this.$store.dispatch(
                "admin/UpdateUserDetails",
                {
                  cancelPlan: true,
                  _id: this.user._id,
                }
              );
              const data2 = await this.$store.dispatch(
                "payment/UpdatePayment",
                {
                  _id: this.getAllPayments.result[0]._id,
                  membershipStatus: "cancelled",
                }
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
@media (min-width: 769px) {
  .custborleft5 {
    border-left: 1px solid;
  }
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #4f0a4b;
  background: #4f0a4b;
}
.el-radio__input.is-checked + .el-radio__label {
  color: none;
}
</style>
